import { lazy } from 'react';

export const Users = lazy(() => import('./ui/Users'));
